import type { TPageTranslations } from '@crehana/i18n';

import { ATS_CAREER_SITE_ADMIN_SHARED } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof ATS_CAREER_SITE_ADMIN_SHARED> =
  {
    [ATS_CAREER_SITE_ADMIN_SHARED]: {
      RECRUITMENT: 'Recruitment',
      CAREER_SITE: 'Career site',
      SUBTITLE_CAREER_SITE:
        'Configure and customize your career site to display your vacancies and attract the best candidates.',
      BANNER_TOP_TEXT:
        'The job offers are demonstrative and serve only to give you an idea of the appearance of the portal.',
      VACANCY: 'Vacancy',
      DEPARTMENT: 'Department',
      POSITION: 'Position',
      CLOSED_DATE: 'Closed date',
      PUBLISHED_DATE: 'Published {{days}}',
      DAY: 'day',
      MONTH: 'month',
      YEAR: 'year',
      DAYS: 'days',
      MONTHS: 'months',
      YEARS: 'years',
      SEARCH_BY_NAME: 'Search by name',
      CLOSED_DATE_CARD: 'Closed date: {{date}}',
      FILTER_BY: 'Filter by',
      SEARCH_BY_DEPARTMENT: 'Search by department',
      NO_DEPARTMENTS_FOUND: 'No departments found',
      TRY_ANOTHER_SEARCH: 'Try another search',
      VACANCY_EXAMPLE: 'Vacancy example',
      OPEN_DATE_EXAMPLE: 'Published 3 days ago',
      DEPARTMENT_EXAMPLE: 'Department example',
      FAILED_TO_EXTRACT_JOB_ID_FROM_VACANCY_LINK:
        'Cannot redirect to the application form',
      VACANCY_LINK_IS_EMPTY: 'Cannot redirect to the application form',
    },
  };
